{
	"type": "line",
	"minzoom": 11,
	"layout": {},
	"paint": {
		"line-offset": [
			"interpolate",
			["exponential", 2],
			["zoom"],
			6,
			["match", ["get", "clearzone_side"], "Left", -2, "Right", 2, 0],
			14.99,
			["match", ["get", "clearzone_side"], "Left", -3, "Right", 3, 0],
			15,
			[
				"*",
				["match", ["get", "clearzone_side"], "Left", -1, "Right", 1, 0],
				[
					"+",
					["to-number", ["get", "clearzone_start_offset_m"]],
					["/", ["to-number", ["get", "backslope_distance_m"]], 2]
				],
				["to-number", ["get", "px_per_m_z20"]],
				0.03125
			],
			20,
			[
				"*",
				["match", ["get", "clearzone_side"], "Left", -1, "Right", 1, 0],
				[
					"+",
					["to-number", ["get", "clearzone_start_offset_m"]],
					["/", ["to-number", ["get", "backslope_distance_m"]], 2]
				],
				["to-number", ["get", "px_per_m_z20"]]
			]
		],
		"line-gap-width": 0,
		"line-width": [
			"interpolate",
			["exponential", 2],
			["zoom"],
			6,
			2,
			14.99,
			2,
			15,
			[
				"*",
				["to-number", ["get", "backslope_distance_m"]],
				["to-number", ["get", "px_per_m_z20"]],
				0.03125
			],
			20,
			["*", ["to-number", ["get", "backslope_distance_m"]], ["to-number", ["get", "px_per_m_z20"]]]
		],
		"line-color": [
			"match",
			["get", "clearzone_grade"],
			"A",
			"#1a9850",
			"B",
			"#91cf60",
			"C",
			"#d9ef8b",
			"D",
			"#fee08b",
			"E",
			"#fc8d59",
			"F",
			"#d73027",
			"Unknown",
			"#aaa",
			"#999999"
		],
		"line-opacity": 0.9
	}
}
